import * as runtime from '@/api/runtime'
import {
  BatchFileUploadResponse,
  BatchFileUploadResponseFromJSON
} from '@/api/models/batch/BatchFileUploadResponse'
import { HTTPHeaders } from '@/api/runtime'

export interface UploadFileRequest {
  data: FormData
}

export class BatchFileUploadApi extends runtime.BaseAPI {
  async upload(
    requestParameters: UploadFileRequest
  ): Promise<BatchFileUploadResponse> {
    const headerParameters: HTTPHeaders = {}
    const response = await this.request({
      path: `/batch/file-upload`,
      method: 'POST',
      headers: headerParameters,
      body: requestParameters.data
    })

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchFileUploadResponseFromJSON(jsonValue)
    ).value()
  }
}
